import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../apis";

export default function () {
    const [redirect, setRedirect] = useState("verifying")

    const location = useLocation();
    const params = new URLSearchParams(location.search);

    useEffect(() => {
        api.get(`/confirm-email?token=${params.get('token')}`).then(response => {
            setRedirect("success")
        }).catch(error => {
            setRedirect("failed")
        })
    }, [])

    return (
        <>
            {redirect === "success"
                ? "You can safely close this page!"
                : (redirect === "verifying" ? "Verifying your email..." : "Cannot verify email. Try again later!")
            }
        </>
    )
}